import React from 'react';
import experiment from 'experiment';
import type { Layout } from 'types/documentServices';
import { connectWithScope } from '#packages/apilib';

import { SlotOpenerScope } from '../scope';
import { SlotOpenerLineSvg } from './slotOpenerLineSvg';
import styles from './slotOpenerLine.scss';

import { getLineRect, getLineRectV3, SLOT_OPENER_AUTOMATION_ID } from './utils';

interface Props {
  linePosition: Layout | null;
  isActive: boolean;
}

const SlotOpenerLine = ({ linePosition, isActive }: Props) => {
  if (!linePosition) {
    return null;
  }

  if (experiment.isOpen('se_slotOpenerV3')) {
    return (
      <SlotOpenerLineSvg
        automationId={SLOT_OPENER_AUTOMATION_ID}
        style={{
          top: linePosition.y,
          left: linePosition.x,
          width: linePosition.width,
          height: linePosition.height,
        }}
        isActive={isActive}
      />
    );
  }

  return (
    <div
      className={styles.slotOpenerLine}
      style={{
        top: linePosition.y,
        left: linePosition.x,
        width: linePosition.width,
        height: linePosition.height,
      }}
    />
  );
};

const mapStateToProps = ({ store }: SlotOpenerScope) => {
  const slot = store.getAvailableSlot();

  const isActive = store.getShouldOpenSlot();

  const getLineFn = experiment.isOpen('se_slotOpenerV3')
    ? getLineRectV3
    : getLineRect;

  return {
    linePosition: slot ? getLineFn(slot, isActive) : null,
    isActive: store.getShouldOpenSlot(),
  };
};

export default connectWithScope(
  () => SlotOpenerScope,
  SlotOpenerLine,
  mapStateToProps,
  null,
  {
    rerenderOnMouseOps: true,
  },
);
